export const getLoggedInLoadingMessages = (t: (key: string, options?: any) => string, key: string | undefined): { title: string; description: string } => {
  if (key == null || key === '') {
    return {
      title: '',
      description: t('common:loggingIn'),
    }
  }
  return {
    title: t(`common:${key}:title`, { defaultValue: '' }),
    description: t(`common:${key}:description`),
  }
}
